import * as runtime from '@/api/runtime'
import {
  BatchTrcAuthorityRegisterRequest,
  BatchTrcAuthorityRegisterRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchTrcAuthorityRegisterCondition,
  BatchTrcAuthorityRegisterConditionFromJSON
} from '@/api/models/batch/BatchTrcAuthorityRegisterCondition'

/**
 * 帳票作成
 */
export class BatchTrcAuthorityRegisterApi extends runtime.BaseAPI {
  async register(request: BatchTrcAuthorityRegisterRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/trc-authority-register`,
      BatchTrcAuthorityRegisterRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTrcAuthorityRegisterCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTrcAuthorityRegisterConditionFromJSON(jsonValue)
    ).value()
  }
}
